<template>
    <app-page-content>
        <app-sub-title text="Usuarios pendientes por activación" />
        <b-row v-if="canSelectClient">
            <b-col cols="12" md="6">
                <v-select
                    :options="clients"
                    label="name"
                    v-model="selectedClient"
                    class="py-3"
                    placeholder="Seleccione el cliente"
                ></v-select>
            </b-col>
        </b-row>
        <app-pending-activation-list
            v-if="!!peopleData"
            :context="peopleData"
            @activate-person="onActivatePerson"
            @reject-person="onRejectUser"
            @change-page="onChangePage"
        />

        <app-pop-up
            id="user-activation"
            size="large"
            title="Activación de usuario aplicación móvil"
            :on-close="restart"
        >
            <div slot="body">
                <app-person-card
                    v-if="!!activation.person"
                    :person="activation.person"
                />
                <b-alert variant="warning" show class="mt-3"
                    ><small
                        >En las notas encuentra la estructura que el usuario
                        indicó a la que pertenece por favor confirme la
                        información</small
                    ></b-alert
                >
                <v-select
                    class="mb-3"
                    placeholder="Seleccione la estructura a la que pertenece"
                    v-model="activation.structure"
                    @change="$v.activation.structure.$touch()"
                    label="name"
                    :options="structures"
                >
                    <template slot="option" slot-scope="option">
                        {{ option.structure_type.name }} | {{ option.name }}
                    </template>
                </v-select>
                <span v-if="$v.activation.structure.$error" class="field-error"
                    >Debe seleccionar la estructura a la que pertenece el
                    usuario</span
                >
            </div>
            <div slot="buttons">
                <b-button
                    variant="confirm"
                    :disabled="inProgress"
                    @click="confirmUserActivation"
                    >Activar Usuario</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="user-reject">
            <div slot="body">
                <h2>¿Esta seguro que desea rechazar este usuario?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="rejectUser(selectedUser)"
                >
                    <i class="fa fa-times" aria-hidden="true"></i> Rechazar
                    usuario
                </button>
            </div>
        </app-pop-up>
    </app-page-content>
</template>
<script>
import mobileUsersRepository from '../../../../repositories/mobileUsers.repository'

import PendingActivationList from './PendingActivationsList/PendingActivationList.vue'
import PopUp from '../../../UI/Controls/PopUp/PopUp.vue'
import PersonCard from '../../../UI/People/PersonCard/PersonCard.vue'
import { required } from 'vuelidate/lib/validators'
import structuresRepository from '../../../../repositories/structures.repository'
import { mapGetters } from 'vuex'

export default {
    components: {
        appPendingActivationList: PendingActivationList,
        appPopUp: PopUp,
        appPersonCard: PersonCard,
    },
    data() {
        return {
            peopleData: null,
            page: 1,
            selectedClient: null,
            structures: [],
            activation: {
                structure: null,
                person: null,
            },
            selectedUser: '',
        }
    },
    validations: {
        activation: {
            structure: { required },
        },
    },
    watch: {
        selectedClient(val) {
            if (!val) return
            this.page = 1
            this.loadPeopleToActivate()
            this.loadStructures()
        },
    },
    computed: {
        ...mapGetters(['clients']),
        people() {
            if (!this.peopleData) return []

            return this.peopleData.data
        },
        theClientId() {
            return !!this.selectedClient
                ? this.selectedClient.id
                : !!this.client
                ? this.client.id
                : null
        },
        canSelectClient() {
            return !this.user.profile.client_side
        },
    },
    methods: {
        async loadPeopleToActivate() {
            // if (!this.theClientId) return
            try {
                const params = {
                    page: this.page,
                }

                if (!this.canSelectClient) {
                    params.client = this.client.id
                } else if (!!this.selectedClient) {
                    params.client = this.selectedClient.id
                }

                const { data } = await repo.get(
                    `people/pending-activation`,
                    params
                )
                const context = {}
                _.forIn(data, (value, key) => {
                    key !== 'data' && (context[_.camelCase(key)] = value)
                })
                this.peopleData = { ...context, items: data.data }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al cargar las activaciones pendientes [${err.message}]`
                )
            }
        },
        loadStructures() {
            if (!this.theClientId) return

            const sr = { ...structuresRepository }
            sr.all(this.theClientId)
                .then((data) => (this.structures = data))
                .catch((error) =>
                    toastr.error('Ocurrió un error al cargar las estructuras')
                )
        },
        restart() {
            Object.keys(this.activation).map(
                (key) => (this.activation[key] = null)
            )
            this.$v.$reset()
        },
        initialize() {
            this.load('clients')
            this.loadPeopleToActivate()
            this.loadStructures()
        },
        onActivatePerson(person) {
            this.selectedClient = person.client
            this.activation.person = person
            this.$bus.$emit('user-activation.open')
        },
        onRejectUser(user) {
            this.selectedUser = user
            this.$bus.$emit('user-reject.open')
        },
        async confirmUserActivation() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            const payload = {
                personId: this.activation.person.id,
                structureId: this.activation.structure.id,
            }

            const pr = { ...mobileUsersRepository }

            try {
                const { data } = await pr.activateMobileUser(payload)

                const { status, msg, user, person } = data

                if (status) {
                    this.loadPeopleToActivate()
                    toastr.success(msg)
                    this.$bus.$emit('user-activation.close')
                    this.restart()
                } else {
                    toastr.error(msg)
                }
            } catch (err) {
                toastr.error(`No se pudo activar el usuario [${err.message}]`)
            } finally {
            }
        },
        rejectUser(user) {
            const mur = { ...mobileUsersRepository }
            mur.rejectUser(user.id)
                .then(({ data }) => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadPeopleToActivate()
                        this.$bus.$emit('user-reject.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch((error) => {
                    toastr.error('No se pudo rechazar el usuario')
                })
        },
        onChangePage(page) {
            this.page = page
            this.loadPeopleToActivate()
        },
    },
    created() {
        this.initialize()
    },
    beforeUpdate() {},
}
</script>
